export const indexMenuLinks = [
  {
    name: 'About',
    link: '/#about',
    icon: 'user-tie',
  },
  {
    name: 'Features',
    link: '/#offer',
    icon: 'dumbbell',
  },
  {
    name: 'Trainers',
    link: '/#projects',
    icon: 'user-friends',
  },
  {
    name: 'Booking',
    link: '/#booking',
    icon: 'calendar-check',
  },
  {
    name: 'Contact',
    link: '/#contact',
    icon: 'address-book',
  },
  // {
  //   name: 'Shop',
  //   link: '/#shop',
  //   icon: 'shopping-cart',
  // },
];

export const blogMenuLinks = [
  {
    name: 'Portfolio',
    link: '/',
    icon: 'code',
  },
  {
    name: 'Blog',
    link: '/blog',
    icon: 'feather-alt',
  },
  {
    name: 'Tags',
    link: '/tags',
    icon: 'tags',
  },
];
